module.exports = __webpack_public_path__ + "static/media/new1.66f52b9b.jpg";